var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "advance-search-collapse" },
    [
      _c("Collapse", _vm._b({}, "Collapse", _vm.bindAttrs, false), [
        _c(
          "div",
          {
            staticClass: "search-condtions",
            attrs: { slot: "content" },
            slot: "content",
          },
          [_vm._t("default")],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }